import React from 'react'
import { EXETEL_URL } from '../constants'

const BottomDetails = () => {
    const items = [
        { title: 'Sales & Product Support:', data: <span>Mon - Fri: 9am - 7pm (Voice Helpline)<br />Weekends & Public Holidays: 10.30am to 5.30pm (Voice Helpline)</span> },
        { title: 'Technical Support:', data: <span>Mon - Fri: 9am to 9pm (Voice Helpline and Live Chat)<br />Weekends & Public Holidays:<div className="ml-0">- 10.30am to 5.30pm (Voice Helpline)<br />- 9am to 9pm (Live Chat)</div></span> },
        { title: 'Order Tracking:', data: <span>Mon - Fri: 9am to 7pm (Voice Helpline); 9am - 9pm (Live Chat)<br /> Weekends & Public Holidays: 9am to 9pm (Live Chat)</span> },
        { title: 'Billing & Accounts:', data: 'Mon - Fri: 9am to 5.30pm (Voice Helpline)' },
    ]

    return (
        <div className='bottom-details'>
            <div className='row'>
                <div className='col-12 d-flex flex-column align-items-center text-center text-lg-left'>
                    <div className='title bold mb-4'>Our teams are here to help. <br className='d-lg-none' />Call us on <a href='tel:133938' className='gtm-site-footer-phone-click bold'>13 39 38</a><span className='d-none d-lg-inline'>.</span></div>
                    <div className='bold mb-4 font-medium color-indigo px-2'>
                        Check out some of our most frequently asked questions at our support centre <a className='underline color-indigo' href="https://support.exetel.com.au/" target='_blank'>here</a>
                    </div>
                    <div className='d-flex align-items-center flex-column w-100'>
                        {items.map((item, key) => {
                            return (
                                <div key={key} className='contact-item'>
                                    <div><h4 className='bold m-0'>{item.title}</h4></div>
                                    <div><p className='m-0'>{item.data}</p></div>
                                </div>
                            )
                        })}
                        <div className='contact-item'>
                            <div></div>
                            <div><p className='m-0'>All times AET</p></div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='row mb-4 mb-lg-5'>
                <div className='col-12 text-center'>
                    <div className='exefix-banner-small'>
                        <img src='/images/icon-exefix.svg' alt='ExFix' width='50px' className='mr-3' />
                        <p>
                            <span className='bold'>Network speed troubles:</span>&nbsp;&nbsp;Use the new ExeFix app without calling into support (24/7).&nbsp;&nbsp;<a href={`${EXETEL_URL}/exefix`} target='_blank' className='underline'>Get the app now</a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BottomDetails



// WEBPACK FOOTER //
// ./resources/js/layout/BottomDetails.js